import SplitPane from "./SplitPane";

export default SplitPane;
